/* Copyright (C) 2018 HTC Global Services, Inc. - All Rights Reserved  */
import { Directive, ElementRef, AfterViewInit, HostListener } from '@angular/core';

@Directive({
  selector: '[appAutofocus]'
})
export class AutofocusDirective implements AfterViewInit {
  constructor(
    private el: ElementRef
  ) { }
  ngAfterViewInit() {
    this.el.nativeElement.focus();  
  }   
}
